/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './download.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/components/process/download/download.component';
import * as i4 from '../../../../../app/components/process/process.listener';
import * as i5 from 'ngx-toastr';
import * as i6 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_DownloadComponent:any[] = [i0.styles];
export const RenderType_DownloadComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DownloadComponent,data:{}});
function View_DownloadComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'spinner']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),[' '])),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(3,0,(null as any),(null as any),0,'i',[['class','fa fa-download']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    ']))],(null as any),(null as any));
}
function View_DownloadComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'badge']],[[2,'animate',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(1,(null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.isAnimating;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = _co.downloadCount;
    _ck(_v,1,0,currVal_1);
  });
}
export function View_DownloadComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),11,'div',[['class',
      'download-progress']],[[2,'show',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),8,'div',[['class','progress-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DownloadComponent_1)),i1.ɵdid(5,16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_DownloadComponent_2)),i1.ɵdid(8,
          16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),[' '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.DownloadComponent = _v.component;
    const currVal_1:any = _co.isDownloading;
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = _co.isDownloading;
    _ck(_v,8,0,currVal_2);
  },(_ck,_v) => {
    var _co:i3.DownloadComponent = _v.component;
    const currVal_0:any = _co.isDownloading;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_DownloadComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-process-download',
      ([] as any[]),(null as any),(null as any),(null as any),View_DownloadComponent_0,
      RenderType_DownloadComponent)),i1.ɵprd(512,(null as any),i4.ProcessListener,
      i4.ProcessListener,([] as any[])),i1.ɵdid(2,2867200,(null as any),0,i3.DownloadComponent,
      [i1.ChangeDetectorRef,i5.ToastrService,i6.BsModalService,i4.ProcessListener],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const DownloadComponentNgFactory:i1.ComponentFactory<i3.DownloadComponent> = i1.ɵccf('app-process-download',
    i3.DownloadComponent,View_DownloadComponent_Host_0,{downloadCount:'downloadCount'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tcG9uZW50cy9wcm9jZXNzL2Rvd25sb2FkL2Rvd25sb2FkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2NvbXBvbmVudHMvcHJvY2Vzcy9kb3dubG9hZC9kb3dubG9hZC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2NvbXBvbmVudHMvcHJvY2Vzcy9kb3dubG9hZC9kb3dubG9hZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvY29tcG9uZW50cy9wcm9jZXNzL2Rvd25sb2FkL2Rvd25sb2FkLmNvbXBvbmVudC50cy5Eb3dubG9hZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJkb3dubG9hZC1wcm9ncmVzc1wiICBbY2xhc3Muc2hvd109XCJpc0Rvd25sb2FkaW5nXCI+XG4gIDxkaXYgY2xhc3M9XCJwcm9ncmVzcy1jb250YWluZXJcIj5cbiAgICA8ZGl2IGNsYXNzPVwic3Bpbm5lclwiICpuZ0lmPVwiaXNEb3dubG9hZGluZ1wiPiA8IS0tIEljb24gdOG6o2kgeHXhu5FuZyAtLT5cbiAgICAgIDxpIGNsYXNzPVwiZmEgZmEtZG93bmxvYWRcIj48L2k+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cImJhZGdlXCIgKm5nSWY9XCJpc0Rvd25sb2FkaW5nXCIgW2NsYXNzLmFuaW1hdGVdPVwiaXNBbmltYXRpbmdcIj57eyBkb3dubG9hZENvdW50IH19PC9kaXY+IDwhLS0gQ2jhuqVtIHbhu5tpIHPhu5EgbMaw4bujbmcgLS0+XG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8YXBwLXByb2Nlc3MtZG93bmxvYWQ+PC9hcHAtcHJvY2Vzcy1kb3dubG9hZD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0VJO01BQUE7TUFBMkMseUNBQXdCO01BQ2pFO1VBQUE7TUFBOEI7OztvQkFFaEM7TUFBQTtNQUFBLGdCQUF1RTs7O0lBQTlCO0lBQXpDLFdBQXlDLFNBQXpDO0lBQXVFO0lBQUE7Ozs7b0JBTDNFO01BQUE7TUFBQSw4QkFBNkQsNENBQzNEO2FBQUE7VUFBQTtNQUFnQyw4Q0FDOUI7VUFBQSxnRUFBQTtVQUFBO1VBQUEsZUFFTSw4Q0FDTjtVQUFBLDhFQUFBO1VBQUE7Y0FBQSx3QkFBZ0cseUNBQTJCO2lCQUFBLDZCQUN2SDtNQUNGOztJQUxtQjtJQUFyQixXQUFxQixTQUFyQjtJQUdtQjtJQUFuQixXQUFtQixTQUFuQjs7O0lBTDRCO0lBQWhDLFdBQWdDLFNBQWhDOzs7O29CQ0FBO01BQUE7a0NBQUE7eUJBQUEsc0JBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/process/download/download.component.ngfactory.ts